import { ScrollReveal } from "@/hooks/useScrollReveal";
import { CATALOG_URL } from "@/mocks/site-config";
import Watermark from "@/components/base/Watermark";

const notices = [
  {
    icon: "ri-heart-pulse-line",
    title: "醫療保健出版內容",
    desc: "網站所呈現的醫療、疾病、健康、營養、照護及保健相關內容，屬於出版與一般知識閱讀資訊，不能取代醫師或其他合格專業人員的診斷、治療與建議。如有健康問題，請諮詢醫療專業人員。",
  },
  {
    icon: "ri-search-line",
    title: "研究與論文出版內容",
    desc: "研究與論文相關出版內容為書籍與知識閱讀，可供一般閱讀、學習與方法理解。崧燁文化不提供論文代寫、研究代做、統計分析、投稿代辦或學位取得等代辦服務。",
  },
  {
    icon: "ri-user-voice-line",
    title: "作者觀點與作品責任",
    desc: "個別作品內容與作者觀點，不代表崧燁文化或崧博出版的官方立場。作者姓名、職稱與所屬機構等資訊，僅限現有正式書籍資料已提供時呈現，不代表品牌本身具有醫療、學術或研究機構資格。",
  },
];

export default function ContentNotice() {
  return (
    <section className="min-h-[80svh] flex items-center bg-background-50">
      <Watermark />
      <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:gap-16 mb-14 md:mb-20">
            <div className="lg:w-[30%] flex-shrink-0 mb-6 lg:mb-0">
              <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium">
                內容說明
              </p>
            </div>
            <div className="lg:w-[70%]">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight">
                出版內容與使用邊界
              </h2>
              <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
                崧燁文化為出版品牌，網站內容用以介紹品牌定位、出版方向與書籍資訊，不代表提供醫療診斷、研究代辦、論文代寫或其他專業代辦服務。
              </p>
            </div>
          </div>
        </ScrollReveal>

        <div className="lg:ml-[30%] lg:pl-16">
          {/* Three notice items */}
          <div className="max-w-lg space-y-6">
            {notices.map((item, i) => (
              <ScrollReveal key={item.title} delay={i * 100}>
                <div className="flex gap-4">
                  <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center">
                    <i className={`${item.icon} text-lg text-primary-600`}></i>
                  </div>
                  <div>
                    <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1.5">
                      {item.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          {/* Bottom: Catalog reference */}
          <ScrollReveal delay={350}>
            <div className="mt-10 max-w-lg bg-background-100 border border-background-200/70 p-5 md:p-6">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                完整書名、作者、ISBN、出版品牌及相關出版資訊，以崧博書籍資料庫中的個別書籍頁為準。
              </p>
              <a
                href={CATALOG_URL}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="bg-foreground-900 hover:bg-foreground-800 text-white px-6 py-3 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors inline-flex items-center justify-center gap-2 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-foreground-400 focus-visible:ring-offset-2"
              >
                前往書籍資料庫
                <i className="ri-external-link-line text-sm"></i>
              </a>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}